(function () {
  function submitCountry(option) {
    var href = option.getAttribute('data-href');
    if (href) {
      window.location.href = href;
      return;
    }
    var value = option.getAttribute('data-value');
    if (!value) return;
    var form = option.closest('form');
    if (!form) return;
    var select = form.querySelector('[data-localization-select]');
    var input = form.querySelector('[data-localization-input]');
    if (select) select.value = value;
    if (input) {
      input.value = value;
      input.setAttribute('value', value);
    }
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var option = event.target.closest('.m-country-switcher .m-select-custom--option[data-value]');
      if (!option) return;
      event.preventDefault();
      event.stopPropagation();
      submitCountry(option);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var select = event.target.closest('.m-country-switcher [data-localization-select]');
      if (!select) return;
      var opt = select.options[select.selectedIndex];
      var href = opt && opt.getAttribute('data-href');
      if (!href) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.href = href;
    },
    true
  );

  function initCollectionGridScroll() {
    var params = new URLSearchParams(window.location.search);
    var hasFilter = Array.from(params).some(function (entry) {
      return /^filter\.(p|v)\./.test(entry[0]) && entry[1].trim() !== '';
    });
    var hash = window.location.hash;
    if (hash !== '#coll-grid' && (!hasFilter || hash)) return;
    // Returning from a product should retain the shopper's place in the results.
    var navigation = window.performance.getEntriesByType('navigation')[0];
    if (navigation && navigation.type === 'back_forward') return;
    if (history.state?.kpCollection?.url === location.pathname + location.search) return;
    var grid = document.getElementById('CollectionProductGrid');
    if (!grid) return;

    var cancelled = false;
    var interactions = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    function cleanup() {
      interactions.forEach(function (name) { window.removeEventListener(name, cancel); });
    }
    function cancel() { cancelled = true; cleanup(); }
    interactions.forEach(function (name) { window.addEventListener(name, cancel, { passive: true, once: true }); });
    setTimeout(cleanup, 5000);

    function alignResults() {
      if (cancelled) return;
      var header = document.querySelector('m-header');
      var wrapper = header && header.querySelector('.m-header__wrapper');
      var sticky = header && /^(always|on_scroll_up)$/.test(header.dataset.sticky);
      var clearance = (sticky && wrapper ? wrapper.offsetHeight : 0) + 16;
      window.scrollTo({ top: Math.max(0, window.scrollY + grid.getBoundingClientRect().top - clearance), behavior: 'instant' });
    }
    window.requestAnimationFrame(alignResults);
    // Async theme CSS and fonts can move the grid after the first alignment.
    // Correct that once, unless the shopper has already started interacting.
    function settle() {
      Promise.resolve(document.fonts && document.fonts.ready).then(function () {
        window.requestAnimationFrame(function () { alignResults(); cleanup(); });
      });
    }
    if (document.readyState === 'complete') settle();
    else window.addEventListener('load', settle, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionGridScroll);
  } else {
    initCollectionGridScroll();
  }
})();

/* Empty-search discovery follows the field, including non-predictive search. */
(() => {
  const popup = document.querySelector('[data-search-popup]');
  const input = popup?.querySelector('[data-search-input]');
  const links = popup?.querySelector('[data-kp-search-empty]');
  if (!input || !links) return;
  const sync = () => { links.hidden = input.value.trim().length > 0; };
  input.addEventListener('input', sync);
  popup.querySelector('[data-clear-search]')?.addEventListener('click', () => requestAnimationFrame(sync));
  popup.querySelector('form')?.addEventListener('reset', () => requestAnimationFrame(sync));
  new MutationObserver(sync).observe(popup, {attributes:true, attributeFilter:['style','class']});
  sync();
})();

(function () {
  // Express checkout height hold (14 Oct 2026). On every option change Shopify's accelerated checkout
  // re-renders and drops its "More payment options" link for about 0.2-0.5 s, so everything under the
  // buttons jumped 40px (Clarity: CLS 0.31 on a wall-bed product page; harness 0.10 on phones). Keep the
  // container at its current height until Shopify has drawn the buttons back, then release (3 s cap).
  function holdPaymentButtons(box) {
    var height = box.offsetHeight;
    if (!height || box.getAttribute('data-kp-hold') === '1') return;
    var inner = box.firstElementChild;
    var started = Date.now();
    var observer = null;
    var timer = null;
    box.setAttribute('data-kp-hold', '1');
    box.style.minHeight = height + 'px';
    function release() {
      box.style.minHeight = '';
      box.removeAttribute('data-kp-hold');
      if (observer) observer.disconnect();
      clearTimeout(timer);
    }
    if (inner && typeof window.ResizeObserver === 'function') {
      observer = new window.ResizeObserver(function () {
        if (Date.now() - started > 120 && inner.offsetHeight >= height - 1) release();
      });
      observer.observe(inner);
    }
    timer = setTimeout(release, 3000);
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.closest || !target.closest('.m-product-option, variant-picker, [data-variant-picker]')) return;
      var scope = target.closest('.shopify-section') || document;
      Array.prototype.forEach.call(scope.querySelectorAll('.shopify-payment-button'), holdPaymentButtons);
    },
    true
  );
})();
